import { useUiModelStore } from "@agent/uiModelStore";
import { queryClient } from "@api/queryClient";
import { useWriteErrorStore } from "@api/writeErrorStore";
import { usePrincipalKey } from "@auth/sessionStore";
import { useEffect, useRef } from "react";

/**
 * On a principal change (user switch or clinic re-pair, not token rotation), drops
 * the previous user's cached data, typed a2ui input and write-failure notice so
 * none of it is shown on a shared device.
 */
export const SessionCacheReset = () => {
  const sessionKey = usePrincipalKey();
  const isInitialSession = useRef(true);

  useEffect(() => {
    if (isInitialSession.current) {
      isInitialSession.current = false;
      return;
    }
    queryClient.clear();
    useUiModelStore.getState().clearAll();
    useWriteErrorStore.getState().dismiss();
  }, [sessionKey]);

  return null;
};
